import { Property } from "./property";

export class OutputProperty extends Property{
    title:string;
}